<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
						<button class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit</button>
						<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggle()">Toggle</button>
						<button class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstConsequence"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedConsequence"
						dataKey="ConsequenceID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--ConsequenceTrigger-->
								<th>
									<!-- <p-columnFilter type="text" field="ConsequenceTrigger" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ConsequenceDesc-->
								<th>
									<p-columnFilter type="text" field="ConsequenceDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ActiveDesc-->
								<th>
									<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterActiveDesc
												[ngModel]="value"
												[options]="lstActiveDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="ConsequenceTrigger">Trigger after Occurences<p-sortIcon field="ConsequenceTrigger"></p-sortIcon></th>
								<th pSortableColumn="ConsequenceDesc">Description<p-sortIcon field="ConsequenceDesc"></p-sortIcon></th>
								<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-Consequence>
							<tr [pSelectableRow]="Consequence" (dblclick)="onRowDblClick(Consequence)">
								<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
									{{ Consequence[col.field] }}
								</td>

								<td
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="Consequence.Active == true ? 'Black' : 'Red'"
								>
									{{ Consequence["ActiveDesc"] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
